import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {SecurityService} from "../services/security.service";

@Injectable({
  providedIn: 'root'
})
export class PermissionValidaGuard {

  constructor(
    private router: Router,
    private securityService: SecurityService
  ) {
  }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const permissionList = next.data.permissionList ?? [];
    if(permissionList.length > 0){
      return this.securityService.checkPermission(permissionList);
    }
    return false;
  }
}
